import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardMetricCardComponent } from '../../../../../../shared/components/dashboard-metric-card/dashboard-metric-card.component';

@Component({
  selector: 'app-station-summary',
  standalone: true,
  imports: [CommonModule, DashboardMetricCardComponent],
  templateUrl: './station-summary.component.html',
  styleUrls: ['./station-summary.component.css'],
})
export class StationSummaryComponent {
  @Input() connectionIssuesCount: number = 0;
  @Input() missingDataCount: number = 0;
  @Input() isLoadingConnectionIssues: boolean = true;
  @Input() isLoadingMissingData: boolean = true;
}
